<div class="py-3 px-4 border-bottom bg-default" *ngIf="!isExternalRental">
  <app-rental-select
    [ctrl]="rentalIdCtrl"
    [multiple]="false"
    placeholder="Select Rental"
    label="Select Rental"
    i18n-placeholder
    i18n-label
  ></app-rental-select>
</div>
<app-loading-section *ngIf="isLoading">
  <div class="text-center text-light text-sm">
    <div i18n>Our AI is putting on it’s thinking cap and analysing feedback from guest reviews.</div>
    <div i18n>Hang in there!</div>
  </div>
</app-loading-section>

<app-empty-table *ngIf="!insights && !isLoading">
  <img src="/assets/images/empty_icons/review-insights.svg" alt="" />
  <h6 i18n>Unlock Guest Sentiment Insights</h6>
  <p i18n>
    Once reviews start coming in, AI will analyze them for trends, feedback, and improvement opportunities — all in one
    place.
  </p>
</app-empty-table>

<div class="p-4" *ngIf="insights">
  <h6
    class="text-uppercase"
    matTooltip="Quick AI-powered overviews of what each guest felt about their stay."
    matTooltipPosition="left"
    i18n-matTooltip
  >
    <ng-contianer i18n>Guest Sentiments</ng-contianer>&nbsp;<i class="cs-icon cs-icon-info-circle"></i>
  </h6>
  <div class="d-flex flex-column gap-3">
    <app-loading-section *ngIf="isLoading"></app-loading-section>
    <div *ngFor="let item of insights?.guests_sentiments.slice(0, 5)" class="d-flex align-items-center gap-3">
      <app-avatar [text]="item.review?.reviewer.name" [size]="35"></app-avatar>
      <div class="flex-fill">
        <div class="text-semi-bold">{{ item.summary }}</div>
        <ul class="dot-segments-list text-light text-sm" *ngIf="item.review">
          <li>{{ item.review?.reviewer.name }}</li>
          <li>{{ item.review?.submittedAt | epoch }}</li>
        </ul>
      </div>
    </div>
    <div class="text-center" *ngIf="insights?.guests_sentiments.length > 5">
      <hr class="my-1" />
      <a href="javascript:void(0)" (click)="onGuestSentiments(insights?.guests_sentiments)" i18n>
        Load More ({{ insights?.guests_sentiments.length }})
      </a>
    </div>
  </div>
  <h6
    class="text-uppercase mt-5"
    matTooltip="Learn what guests thought could enhance their stay."
    matTooltipPosition="left"
    i18n-matTooltip
  >
    <ng-contianer i18n>Suggested Improvements</ng-contianer>&nbsp;<i class="cs-icon cs-icon-info-circle"></i>
  </h6>
  <div class="d-flex flex-column gap-3">
    <app-loading-section *ngIf="isLoading"></app-loading-section>
    <div *ngFor="let item of insights?.suggested_improvements" class="d-flex align-items-center gap-3">
      <div
        class="avatar-icon text-primary bg-secondary-primary rounded-circle d-flex align-items-center justify-content-center border-primary text-xxl"
      >
        <i class="cs-icon cs-icon-light-stars"></i>
      </div>
      <div class="flex-fill">
        <div class="text-semi-bold">{{ item.suggestion }}</div>
        <div class="text-warning text-sm">{{ item.why_suggested }}</div>
      </div>
    </div>
  </div>
  <h6
    class="text-uppercase mt-5"
    matTooltip="Learn how you can increase your revenue based on guest feedback"
    matTooltipPosition="left"
    i18n-matTooltip
  >
    <ng-contianer i18n>Revenue Suggestions</ng-contianer>&nbsp;<i class="cs-icon cs-icon-info-circle"></i>
  </h6>
  <div class="d-flex flex-column gap-3">
    <app-loading-section *ngIf="isLoading"></app-loading-section>
    <div *ngFor="let item of insights?.revenue_suggestions" class="d-flex align-items-center gap-3">
      <div
        class="avatar-icon text-indigo bg-secondary-indigo rounded-circle d-flex align-items-center justify-content-center border-indigo text-xl text-bold"
      >
        $
      </div>
      <div class="flex-fill">
        <div class="text-semi-bold">{{ item.suggestion }}</div>
        <div class="text-primary text-sm">{{ item.why_suggested }}</div>
      </div>
    </div>
  </div>
  <h6
    class="text-uppercase mt-5"
    matTooltip="Overall average rating of guest reviews for this rental"
    matTooltipPosition="left"
    i18n-matTooltip
  >
    <ng-contianer i18n>Recent Review Trends</ng-contianer>&nbsp;<i class="cs-icon cs-icon-info-circle"></i>
  </h6>
  <app-loading-section *ngIf="isLoading"></app-loading-section>
  <div class="d-flex align-items-center gap-2" *ngIf="ratingByRentalId?.[rentalIdCtrl.value] as rating">
    <span class="text-light" i18n>Overall guest sentiment score:</span>
    <span class="text-bold">
      {{ rating.channelAverageOverallRating | number : '1.0-2' }}/{{ getMaxRating(rating) }}
    </span>
    <app-rating [maxRating]="getMaxRating(rating)" [rating]="rating.channelAverageOverallRating"></app-rating>
  </div>
  <div class="d-flex gap-3 mt-3">
    <div class="p-3 bg-secondary-success rounded flex-1">
      <div class="text-success text-semi-bold" i18n>Positive Mentions</div>
      <div class="text-light">
        <div *ngFor="let item of insights?.review_trends.positive">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="p-3 bg-secondary-danger rounded flex-1">
      <div class="text-danger text-semi-bold" i18n>Negative Mentions</div>
      <div class="text-light">
        <div *ngFor="let item of insights?.review_trends.negative">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</div>
